const feeField = document.querySelector<HTMLSelectElement>('#fee');
const customFeeField =
	document.querySelector<HTMLInputElement>('#custom-fee input');

// Toggle custom fee field.
function toggleCustomFee() {
	if (!feeField || !customFeeField) {
		return;
	}

	const {value} = feeField.options[feeField.selectedIndex];
	const isCustomFee = value === 'custom';
	customFeeField.required = isCustomFee;
	if (customFeeField.parentElement) {
		customFeeField.parentElement.hidden = !isCustomFee;
	}
}

// Check for changes on the fee field.
if (feeField && customFeeField) {
	toggleCustomFee();
	feeField.addEventListener('change', toggleCustomFee);
}
